import React, { Component } from 'react';
import applicationRouter from '~/hoc/applicationRouter';
import { inject, observer } from 'mobx-react';
import moment from 'moment/min/moment-with-locales'; // 'moment/min/moment-with-locales';
import _ from 'lodash';
import { statusMap } from '~/utils/normalStatuses';
import withLocalization from '~/hoc/withLocalization';
import { Row, Col } from 'react-bootstrap';
import LoadingSpinner from '~/elements/LoadingSpinner';

class VacationsTotals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadedUser: null,
        };
    }

    loadData() {
        if (!this.props.user) {
            this.setState({ loadedUser: this.props.userStore.currentUser });
        } else {
            this.props.userStore.pullUserById(this.props.user).then((user) => {
                this.setState({ loadedUser: user });
            });
        }
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.user, this.props.user)) {
            this.loadData();
        }
    }

    render() {
        const { t, userStore } = this.props;
        const { yearlyTotalVacation } = userStore;
        const { loadedUser } = this.state;

        if (!loadedUser)
            return <LoadingSpinner />;

        return (
            <Row className="mb-4 align-items-center">
                <Col md={9} className={'mt-2'}>
                    <Row>
                        <Col xs={6} sm={4} md={2} className={'mt-2'}>
                            <div className="vacation-panel__item vacation-panel__divider">
                                <span className="vacation-panel__value">{moment(new Date()).year()}</span>
                                <span title={t('Year')} className="vacation-panel__label">{t('Year')}</span>
                            </div>
                        </Col>
                        <Col xs={6} sm={4} md={2} className={'mt-2'}>
                            <div className="vacation-panel__item">
                                <span className="vacation-panel__value">{loadedUser.employee_percent}%</span>
                                <span title={t('Employment')} className="vacation-panel__label">{t('Employment')}</span>
                            </div>
                        </Col>
                        <br />
                        <Col xs={6} sm={4} md={2} className={'mt-2'}>
                            <div className="vacation-panel__item">
                                <span className="vacation-panel__value">{yearlyTotalVacation.vacationsTotal}</span>
                                <span title={t('Total days')} className="vacation-panel__label vacation-panel__gradient_underline">{t('Total days')}</span>
                            </div>
                        </Col>
                        <Col xs={6} sm={4} md={2} className={'mt-2'}>
                            <div className="vacation-panel__item">
                                <span className="vacation-panel__value">{yearlyTotalVacation.vacationDays}</span>
                                <span title={t('approved')} className="vacation-panel__label vacation-panel__gradient_underline">{t('approved')}</span>
                            </div>
                        </Col>
                        <Col xs={6} sm={4} md={2} className={'mt-2'}>
                            <div className="vacation-panel__item">
                                <span className="vacation-panel__value">{yearlyTotalVacation.pendingVacation}</span>
                                <span title={t('Pending')} className="vacation-panel__label vacation-panel__gradient_underline">{t('Pending')}</span>
                            </div>
                        </Col>
                        <Col xs={6} sm={4} md={2} className={'mt-2'}>
                            <div className="vacation-panel__item">
                                <span className="vacation-panel__value">
                                    {yearlyTotalVacation.vacationsTotal -
                                        yearlyTotalVacation.vacationDays -
                                        yearlyTotalVacation.pendingVacation}
                                </span>
                                <span title={t('Remaining')} className="vacation-panel__label vacation-panel__gradient_underline">{t('Remaining')}</span>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col md={3} className={'mt-3'}>
                    <Row className='d-flex align-items-center'>
                        {this.props.currentvacation &&
                            <Col>
                                <div
                                    className={`status-block status-block__fixed-width status-${this.props.currentvacation ? this.props.currentvacation.vacation.status : null
                                        }`}
                                >
                                    {t(this.props.currentvacation ? statusMap[this.props.currentvacation.vacation.status] : null)}
                                </div>
                            </Col>
                        }
                    </Row>
                </Col>
            </Row>
        );
    }
}
export default inject('absenceStore', 'userStore', 'commonStore')(applicationRouter(withLocalization(observer(VacationsTotals))));
